import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Subscription, interval } from 'rxjs';
import { AppConfigService } from './core/services/app-config.service';
import { startWith } from 'rxjs/operators';
import { ConfirmationService } from 'primeng/api';
import {UserProfileService} from './features/users/services/user-profile.service';

@Component({
  selector: 'app-root',
  template: require('./app.component.html'),
  styles: [require('./app.component.sass')]
})
export class AppComponent implements OnInit, OnDestroy {

  toastShowSubscription: Subscription;
  nmsVersionSubscription: Subscription;
  periodCheckingNewVersion: number = 60000; // every minute

  constructor(
    public translate: TranslateService,
    private cookieService: CookieService,
    @Inject('$rootScope') $rootScope: any,
    private appConfigService: AppConfigService,
    private confirmationService: ConfirmationService,
    private userProfileService: UserProfileService
  ) {
    const languages = environment && environment.languages && environment.languages.items;
    translate.addLangs(languages.map(lang => lang.code));

    const currentLanguage = localStorage.getItem('nomad.noc.ng.language') || 'en';

    this.setLanguage();

    this.userProfileService.updateProfile('nomad.noc.ng.units', this.cookieService.get('nomad.noc.ng.units') || 'metric')

    $rootScope.$on('localeChanged', () => {
      this.setLanguage();
    })

    $rootScope.$broadcast('localeChanged', currentLanguage);
    $rootScope.$broadcast('timeZoneChanged');
    $rootScope.$broadcast('unitsChanged');
  }

  ngOnInit () {
    /*this.nmsVersionSubscription = interval(this.periodCheckingNewVersion).pipe(startWith(0)).subscribe(() => {
      this.checkVersion()
    });*/
  }

  checkVersion = async () => {
    if (this.cookieService.get('nomad.noc.ng.token')) {
      const localVersion = this.cookieService.get('nms-version');
      const remoteVersion = await this.appConfigService.getNMSversion().toPromise();
      if (localVersion !== remoteVersion) {
        this.confirmationService.confirm({
          message: this.translate.instant('I18N_GENERAL.ASK_LOAD_NEW_VERSION'),
          header: this.translate.instant('I18N_GENERAL.NEW_VERSION_DETECTED'),
          icon: 'pi pi-exclamation-triangle',
          rejectLabel: this.translate.instant('I18N_GENERAL.NO'),
          acceptLabel: this.translate.instant('I18N_GENERAL.YES'),
          accept: () => {
            this.cookieService.set('nms-version', remoteVersion);
            window.location.reload(true)
          },
          reject: () => {
    
          },
        });
      }
    }
  }

  setLanguage = () => {
    const currentLanguage = localStorage.getItem('nomad.noc.ng.language') || 'en';
    this.translate.use(currentLanguage);
  }

  ngOnDestroy() {
    this.nmsVersionSubscription.unsubscribe();
  }
  
}
